import {CREATED, INTERNAL_SERVER_ERROR, NO_CONTENT, OK} from "../constants/response-status-codes";
import { genericError } from "../models/GenericError";
import { SettingData } from "../models/SettingData";
import { StoreEntityResult } from "../models/services/StoreEntityResult";
import { APIConnector } from "./api/APIConnector";
import { processServerError, getConstraintViolation } from "./utilities/ServiceError";
import { Deserializer } from 'jsonapi-serializer';

const apiConnector = new APIConnector();

export const saveSettingData = async (settingData: SettingData): Promise<{ id: string, success: boolean }> => {
    try {
        const createNew: boolean = !settingData.id;
        const record = {
            data: {
                id: settingData.id,
                type: "settingData",
                attributes: {
                    sdValstring: settingData.sdValstring,
                    eSysnameLookup: settingData.eSysnameLookup,
                },
                relationships: buildRelationshipsForSettingData(settingData)
            },
        }
        const url = `settingData${createNew ? '' : `/${settingData.id}`}`;
        let response;

        await apiConnector.sendData(url, createNew, record).then(data => {
            response = data;
        }).catch(error => {
            return new Promise((resolve, reject) => {
                return reject(processServerError(error));
            })
        });

        return new Promise<StoreEntityResult>(async (resolve, reject) => {
            if (response) {
                if (createNew) {
                    const content = await response.json();
                    if (content.errors) {
                        return reject({ status: response.status, message: content.errors.map(error => getConstraintViolation(error.detail)) })
                    }

                    new Deserializer().deserialize(content, (error, newCompany) => {
                        if (error) {
                            return reject({ status: response.status, id: newCompany.id, success: false, message: genericError });
                        }
                        return resolve({ id: newCompany.id, success: true });
                    })

                    return;
                }

                if (response.status === NO_CONTENT) {
                    return resolve({ id: settingData.id, success: true })
                }

                const content = await response.json();
                return reject({ status: response.status, id: settingData.id, success: false, message: content.errors.map(error => getConstraintViolation(error.detail)) });
            }

            return reject({ status: INTERNAL_SERVER_ERROR, id: settingData.id, success: false, message: genericError });
        })
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
};

export const buildRelationshipsForSettingData = (settingData: SettingData) => {
    let relations: any = {}
    if (settingData.relationship) {
        settingData.relationship.forEach((relation) => {
            const key = relation.relationType ? relation.relationType : relation.type;
            const currentRelation = {
                [key]: {
                    data: {
                        id: relation.id,
                        type: relation.type
                    }
                }
            }
            relations = { ...relations, ...currentRelation };
        });
    }
    return relations;
}

export const deleteSettingData = async (id: string): Promise<{ id: string, success: boolean }> => {
    try {
        const url = `settingData/${id}`;
        const userLogin = {
            data: {
                type: "settingData",
                id: id
            }
        }

        const response = await apiConnector.deleteData(url, userLogin)

        return new Promise(async (resolve, reject) => {
            if (response.status === NO_CONTENT) {
                return resolve({ id: id, success: true })
            }
            const json = await response.json();

            return reject({ status: response.status, id: id, success: false, message: getConstraintViolation(json.errors[0].detail) });
        })
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}
